import React, { useEffect, useState } from "react";
import { useIdleTimer } from "react-idle-timer";
import { Button, Modal } from "react-bootstrap";
import { UseAuthenticator } from "@aws-amplify/ui-react";
import { API, graphqlOperation } from "aws-amplify";
import * as queries from "../../graphql/mutations";
import { GraphQLResult } from "@aws-amplify/api-graphql";

type logoutResponse = { logoutUser: { success: boolean } };

const SESSION_IDLE_MINUTES = 12;
const PROMPT_IDLE_MINUTES = 2;

interface AutoLogoutProps {
  children?: React.ReactNode;
  signOut?: UseAuthenticator["signOut"];
}

export const AutoLogout = ({ children, signOut }: AutoLogoutProps) => {
  const [remaining, setRemaining] = useState<number>(SESSION_IDLE_MINUTES);
  const [open, setOpen] = useState<boolean>(false);

  const onIdle = () => {
    setOpen(false);
    const logout = async () => {
      try {
        const response = (await API.graphql(graphqlOperation(queries.logoutUser))) as GraphQLResult<logoutResponse>;

        console.log("logout response: ", response);

        if (response.errors) {
          console.log("logout error: ", response.errors);
          throw new Error("Sorry, something went wrong with logging out.");
        }

        const logoutSuccessful: boolean = response.data.logoutUser.success;
        console.log("Logout successful: ", logoutSuccessful);

        // Handle the successful logout, e.g., clear user session or redirect
        if (logoutSuccessful) {
          // Clear user session or redirect as necessary
          console.log("User logged out successfully.");
        } else {
          console.log("Logout failed.");
        }
      } catch (error) {
        console.error("Error during logout: ", error);
      }
    };
    logout();
    signOut();
  };

  const onActive = () => {
    setOpen(false);
  };

  const onPrompt = () => {
    setOpen(true);
  };

  const { getRemainingTime, activate } = useIdleTimer({
    onIdle,
    onActive,
    onPrompt,
    timeout: 1000 * 60 * SESSION_IDLE_MINUTES,
    promptBeforeIdle: 1000 * 60 * PROMPT_IDLE_MINUTES,
    throttle: 500,
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setRemaining(Math.ceil(getRemainingTime() / 1000));
    }, 500);

    return () => {
      clearInterval(interval);
    };
  });

  const handleStillHere = () => {
    activate();
  };

  // const timeTillPrompt = Math.max(remaining - (1000 * 60 * PROMPT_IDLE_MINUTES) / 1000, 0)
  // const seconds = timeTillPrompt > 1 ? 'seconds' : 'second'

  return (
    <>
      <Modal show={open} onHide={handleStillHere} backdrop="static" keyboard={false} dialogClassName={""}>
        <Modal.Header closeButton>
          <Modal.Title>Are you still here?</Modal.Title>
        </Modal.Header>
        <Modal.Body>You will be logged out in {remaining} seconds</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleStillHere}>
            I am still here!
          </Button>
        </Modal.Footer>
      </Modal>
      {children}
    </>
  );
};
